var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6659_59686)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 26.5,
    r: 21.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 26.5,
    r: 21,
    stroke: "#FCF7F7"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6659_59686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.2611 20.1286L36.0917 19.0983L36.2041 18.8615C36.6963 17.8251 36.2536 16.5815 35.2173 16.0892L33.3487 15.2018C32.8468 14.9633 32.282 14.9348 31.7583 15.1211C31.2347 15.3075 30.815 15.6866 30.5765 16.1887L30.4641 16.4255L28.2947 15.3951C27.1596 14.8561 25.7974 15.341 25.2582 16.476L24.7028 17.6453C24.6146 17.8309 24.6039 18.0439 24.6727 18.2374C24.7417 18.4309 24.8846 18.5892 25.0702 18.6774L30.8192 21.4079H23.214C22.9974 21.4079 22.7907 21.4986 22.6441 21.658C22.4974 21.8175 22.4242 22.031 22.4421 22.2469L23.4602 34.463C23.5787 35.8854 24.7896 36.9995 26.2169 36.9995H31.9135C33.3407 36.9995 34.5516 35.8854 34.6701 34.463L35.57 23.6643L37.7549 24.7019C37.8621 24.7529 37.9752 24.777 38.0866 24.777C38.3763 24.777 38.6543 24.6137 38.7869 24.3345L39.3422 23.1654C39.8811 22.03 39.3962 20.6678 38.2611 20.1286ZM31.976 16.8533C32.0369 16.7251 32.1441 16.6283 32.2778 16.5805C32.4117 16.533 32.5558 16.5402 32.684 16.6012L34.5525 17.4885C34.8173 17.6143 34.9304 17.9321 34.8046 18.1969L34.6922 18.4337L31.8634 17.0902L31.976 16.8533ZM33.126 34.3343C33.0739 34.96 32.5412 35.4501 31.9134 35.4501H26.2168C25.5889 35.4501 25.0562 34.96 25.0041 34.3343L24.056 22.957H34.0743L33.126 34.3343ZM37.9425 22.5006L37.7196 22.97L26.4346 17.6101L26.6576 17.1406C26.8303 16.7769 27.2667 16.6218 27.6301 16.7944L37.5964 21.5279C37.96 21.7007 38.1153 22.137 37.9425 22.5006Z",
    fill: "#606062"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6659_59686",
    x: 0,
    y: 0,
    width: 63,
    height: 63,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.909804 0 0 0 0 0.313726 0 0 0 0 0.313726 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6659_59686"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6659_59686",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6659_59686"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(20 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignDelete);
export default __webpack_public_path__ + "static/media/signDelete.b2035fbe817d477c0a9840a381569216.svg";
export { ForwardRef as ReactComponent };